export default __webpack_public_path__ + "static/media/kanvesllc.9b10ec58.webp";